import { render, staticRenderFns } from "./XhStructureCell.vue?vue&type=template&id=6b5d78ca&scoped=true"
import script from "./XhStructureCell.vue?vue&type=script&lang=js"
export * from "./XhStructureCell.vue?vue&type=script&lang=js"
import style0 from "./XhStructureCell.vue?vue&type=style&index=0&id=6b5d78ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d78ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5d78ca')) {
      api.createRecord('6b5d78ca', component.options)
    } else {
      api.reload('6b5d78ca', component.options)
    }
    module.hot.accept("./XhStructureCell.vue?vue&type=template&id=6b5d78ca&scoped=true", function () {
      api.rerender('6b5d78ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhStructureCell.vue"
export default component.exports